import { COLORS } from 'consts/colors'
import styled from 'styled-components'

export const UploadMediaSectionContainer = styled.div`
  display: flex;
  flex-direction: column;
  gap: 10px;

  .tinted {
    font-size: 12px;
    color: ${COLORS.secondarySemiDark};
    font-weight: 500;
  }
`

export const ModelInfo = styled.div`
  display: flex;
  flex-direction: column;
  gap: 4px;
`
